// extracted by mini-css-extract-plugin
export default {"video":"gV0GNF","preview":"QoxIBI","icon":"PMI4TT"};